import { Permission } from '~/typings/enums';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/status/announcements',
        name: 'status.announcement.overview',
        component: async () => import('../views/Status/AnnouncementOverview.vue'),
        meta: {
            title: 'Status mededelingen',
            permission: [
                Permission.Global_StatusAnnouncements_View,
            ],
        },
    },
    {
        path: '/status/announcements/:uuid',
        name: 'status.announcement.detail',
        component: async () => import('../views/Status/AnnouncementDetail.vue'),
        meta: {
            title: 'Status mededeling bekijken',
            permission: [
                Permission.Global_StatusAnnouncements_View,
            ],
        },
    },
];

export default routes;
